// Пункт меню «раскрыт», пока менеджер внутри его раздела: на самом разделе и на любой вложенной
// странице (/deals/create, /deals/deal/123/…, /cars/car/5/…), а не только на страницах из подменю.
// Корень «/» раскрывать нельзя — он префикс у всех адресов.
export const isInSection = (pathname, path) =>
  Boolean(path) && path !== '/' && (pathname === path || pathname.startsWith(`${path}/`));
